<template>
  <va-select-input v-if="editable" color="yellow" source="scopes" multiple></va-select-input>
  <v-chip-group v-else>
    <v-chip v-for="(item, i) in scopes" :key="i" color="yellow" :small="small">
      <va-select-field source="scopes" :item="item"></va-select-field>
    </v-chip>
  </v-chip-group>
</template>

<script>
export default {
  name: 'ScopesSelector',
  props: {
    scopes: {
      type: Array,
      default: () => [],
    },
    editable: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="sass"></style>
